import { render } from "./HomeAddUser.vue?vue&type=template&id=c6cb44d8&scoped=true"
import script from "./HomeAddUser.vue?vue&type=script&lang=js"
export * from "./HomeAddUser.vue?vue&type=script&lang=js"

import "./HomeAddUser.vue?vue&type=style&index=0&id=c6cb44d8&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6cb44d8"]])

export default __exports__